<template>
    <validation-provider v-slot="{ errors }" name="CNES">
        <b-form-group label="CNES" label-for="cnes-input">
            <b-form-input id="cnes-input" v-model="selected" placeholder="0000000" type="text" v-mask="'#######'" @blur="formatCNES"/>
            <small v-if="errors.length" class="text-danger d-block">{{ errors[0] }}</small>
        </b-form-group>
    </validation-provider>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue';
import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
    props: {
        value: {
            type: String,
            required: false,
            default: '',
        },
    },
    components: {
        BFormGroup, BFormInput, ValidationProvider
    },
    data() {
        return {
            required,
            selected: null,
        }
    },
    mounted() {
        this.selected = this.value
    },
    methods: {
      formatCNES() {
        if (this.selected) {
          this.selected = this.selected.padStart(7, '0');
          this.$emit('updated', this.selected);
        }
      }
    }
}
</script>